import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Step 5 (review) for bulk mode: generation guidelines.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function BulkReviewStep({
  articleType,
  bulkTopic,
  contentType,
  language,
  numberOfArticles,
  toneOfVoice,
}) {
  const { t } = useTranslation();

  return (
    <div className="">
      {articleType === 'bulk' ? (
        /* Bulk Articles Guidelines */
        <div className="bg-neutral-50 rounded-lg p-6 mb-6">
          <h3 className="text-lg font-medium text-neutral-900 mb-4">{t('articles.create.bulk.guidelinesTitle')}</h3>
          <div className="space-y-3 text-neutral-800">
            <p><strong>{t('articles.create.bulk.topic')}:</strong> {bulkTopic}</p>
            <p><strong>{t('articles.create.bulk.articlesCount')}:</strong> {numberOfArticles}</p>
            <p><strong>{t('articles.create.bulk.contentType')}:</strong> {contentType || 'blogpost'}</p>
            <p><strong>{t('articles.create.bulk.language')}:</strong> {language || 'polski'}</p>
            <p><strong>{t('articles.create.bulk.tone')}:</strong> {toneOfVoice || 'casual'}</p>
          </div>
          <div className="mt-4 p-4 bg-white rounded border border-neutral-200">
            <h4 className="font-medium text-neutral-900 mb-2">{t('articles.create.bulk.whatWillHappen')}</h4>
            <ul className="list-disc list-inside space-y-1 text-sm text-neutral-700">
              <li>{t('articles.create.bulk.stepQueued', { count: numberOfArticles })}</li>
              <li>{t('articles.create.bulk.stepUnique', { topic: bulkTopic })}</li>
              <li>{t('articles.create.bulk.stepSettings')}</li>
              <li>{t('articles.create.bulk.stepBackground')}</li>
              <li>{t('articles.create.bulk.stepMonitor')}</li>
            </ul>
          </div>
        </div>
      ) : null}
    </div>
  );
}
